import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { space, themeGet } from 'styled-system';

export const Loader = ({ className, ...styledProps }: any) => (
  <div className={className}>
    <StyledLoader {...styledProps}>
      <LoaderBounce />
      <LoaderBounce delay={-1} />
    </StyledLoader>
  </div>
);

const StyledLoader = styled.div`
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
  width: 40px;
  height: 40px;
  ${space};
`;

const bounce = keyframes`
  0%,
  100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
`;

const LoaderBounce = styled.div<{ delay?: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${themeGet('colors.primary') || themeGet('colors.loader')};
  border-radius: 50%;
  opacity: 0.6;
  animation: ${bounce} 2s infinite ease-in-out;
  ${props =>
    props.delay &&
    css`
      animation-delay: ${props.delay}s;
    `}
`;
